module.exports = __webpack_public_path__ + "static/img/findworka-logo.6b8fb5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/findworka-logo.png
// module id = m4D9
// module chunks = 0